// extracted by mini-css-extract-plugin
export default {"button":"appstore_button_button__p0NHP","button-content":"appstore_button_button-content__qMGGF","text":"appstore_button_text__fAIO1","logo":"appstore_button_logo__zWVUe"};